/**
 * Formaterer ein dato til relativ tid (t.d. "for 2 dagar sidan", "for 1 veke sidan")
 * @param {string|Date} date - ISO-datostreng eller Date-objekt
 * @returns {string} Relativ tidsstreng
 */
export function formatDistanceToNow(date) {
  const now = new Date();
  const past = new Date(date);
  const diffInSeconds = Math.floor((now - past) / 1000);

  if (diffInSeconds < 60) {
    return 'akkurat no';
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return diffInMinutes === 1 ? 'for 1 minutt sidan' : `for ${diffInMinutes} minutt sidan`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return diffInHours === 1 ? 'for 1 time sidan' : `for ${diffInHours} timar sidan`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    if (diffInDays === 1) return 'i går';
    return `for ${diffInDays} dagar sidan`;
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return diffInWeeks === 1 ? 'for 1 veke sidan' : `for ${diffInWeeks} veker sidan`;
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return diffInMonths === 1 ? 'for 1 månad sidan' : `for ${diffInMonths} månader sidan`;
  }

  const diffInYears = Math.floor(diffInDays / 365);
  return diffInYears === 1 ? 'for 1 år sidan' : `for ${diffInYears} år sidan`;
}
